import { writable } from "svelte/store";
class TabsContext {
    constructor(initialTabs) {
        this.tabHistory = [];
        this.currentTab = writable(undefined);
        this.tabsList = writable(initialTabs);
    }
    openTab(tabName) {
        this.currentTab.set(tabName);
        this.tabHistory.push(tabName);
    }
    closeTab(tabName) {
        const tabFilter = (elem) => elem != tabName;
        this.tabHistory = this.tabHistory.filter(tabFilter);
        this.openTab(this.tabHistory.pop());
        this.tabsList.update((tabsList) => tabsList.filter(tabFilter));
    }
    addTab(tabName) {
        this.tabsList.update((tabsList) => [...new Set([...tabsList, tabName])]);
        this.openTab(tabName);
    }
}
export default TabsContext;
